export const OSANO_COOKIES_BY_CLASSIFICATION = [
    { classification: 'ANALYTICS' as const, name: 'amp_device_id' },
    { classification: 'ANALYTICS' as const, name: 'amp_session_id' },
    { classification: 'ANALYTICS' as const, name: 'distributionMethod' },
    { classification: 'ANALYTICS' as const, name: 'distributionType' },
    { classification: 'ANALYTICS' as const, name: 'Last-User-ID' },
    { classification: 'ESSENTIAL' as const, name: 'Session-ID' },
    { classification: 'ESSENTIAL' as const, name: 'User-ID' },
    { classification: 'ESSENTIAL' as const, name: 'vid' },
    { classification: 'ESSENTIAL' as const, name: 'wrapper' },
    { classification: 'ESSENTIAL' as const, name: 'X-Cpp-Region' },
    { classification: 'ESSENTIAL' as const, name: 'osano_consentmanager' },
    { classification: 'ESSENTIAL' as const, name: 'osano_consentmanager_uuid' }
];
